var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79 78.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #f2b70a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,78.3H0v-2c.3,1.1.9,1.7,2,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79,10.9v37.2c-.3,1-.4,2-.8,3-3,8.1-10.7,7.9-17.9,9l-14.5,14.6c-.9.6-2.2.6-3-.2s-.7-1-.7-1.2v-10.9l-28.8,3.9c-4.8.3-9.4-2-11.7-6.2S.3,57.1,0,55.5V18.1c.8-5.6,5.1-10,10.7-10.8L65.3,0c6.5-.8,13,4.3,13.7,10.8h0ZM35.9,20.8c-11.1,1-15.1,15.4-6.4,22.2,8.7,6.8,21,0,20.1-11s-6.8-11.8-13.8-11.1h0ZM22.9,40.8h-8.2l-.2-.2v-18.1s-.4-.7-.5-.8c-1.3-1.6-3.9-.7-4.1,1.3.4,6.4-.6,13.6,0,19.9s1,2.4,2.6,2.5,8.6.2,10.2,0,2.2-1.8,1.6-3.2-1-1.2-1.3-1.3h-.1ZM67.5,40.8h-8.2l-.2-.2v-18.1c0-.3-.8-1.1-1-1.3-1.8-1-3.3.2-3.6,2.1-.7,6,.5,13.1,0,19.2,0,1.6.7,2.6,2.4,2.8s8.3.3,10.1,0c2.8-.5,2.5-4.2.5-4.6h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7,27.6c3.9-3.9,10.6-2.6,12.7,2.4,2.8,6.4-3,12.6-9.7,10.6s-7.1-9-3.1-12.9h.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLol);
export default __webpack_public_path__ + "static/media/lol.6621ae844d0cf29cf789cacc2ea35b58.svg";
export { ForwardRef as ReactComponent };